export default "__VITE_ASSET__BRD_7S$Y__"